import request from '@/utils/axios'
import qs from 'qs'

/**
 * 根据学生id获取学生可选的班级类型
 * @param {*} stuId
 */
export function getStudentAndClassTypeListByStuId(stuId) {
    return request({
        url: '/api/manager/studentandclasstype/' + stuId,
        method: 'get',
    })
}

/**
 * 添加学生可选的班级类型
 * @param {*} params 
 */
export function addStudentAndClassType(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/studentandclasstype',
        method: 'post',
        data: postData
    })
}

export function addMultipleStudentAndClassType(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/studentandclasstype/mulitiple',
        method: 'post',
        data: postData
    })
}

/**
 * 修改学生可选的班级类型
 * @param {*} params 
 */
export function editStudentAndClassType(params) {
    let postData = qs.stringify(params)
    return request({
        url: 'api/manager/studentandclasstype',
        method: 'put',
        data: postData
    })
}

/**
 * 删除学生可选的班级类型
 * @param {*} id 
 */
export function deleteStudentAndClassType(id) {
    return request({
        url: 'api/manager/studentandclasstype/' + id,
        method: 'delete',
    })
}